export default "assets/images/logo-982cd37c.svg";